var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineStyleIconDirsvc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 22,
    width: 4,
    height: 4,
    rx: 2,
    ry: 2,
    fill: "#005B90"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 22,
    width: 4,
    height: 4,
    rx: 2,
    ry: 2,
    fill: "#005B90"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 4,
    height: 4,
    rx: 2,
    ry: 2,
    fill: "#005B90"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 22,
    width: 4,
    height: 4,
    rx: 2,
    ry: 2,
    fill: "#005B90"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 4,
    height: 4,
    rx: 2,
    ry: 2,
    fill: "#005B90"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineStyleIconDirsvc);
export default __webpack_public_path__ + "static/media/line-style-icon-dirsvc.63dace5beda4ce37525c3307c5a3a772.svg";
export { ForwardRef as ReactComponent };